// @flow
/** @jsx isolateComponent */

import { Screen } from '@zapier/theme';
import { isolateComponent } from '@zapier/common-utils';
import { useMediaProps } from '@zapier/responsive-utils';
import { ButtonGroup, GridLayout } from '@zapier/common-components';
import {
  Colors,
  Heading,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';

import { type Node } from 'react';

const styles = {
  h2: {
    ...Typography.header800,
    color: Colors.grey900,
    marginBottom: 20,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

type Props = {
  bodyText: Node,
  buttons: Node[],
  headingText: Node,
  image: Node,
  subtitleText: string,
};

const ContentWrapper = ({
  bodyText,
  buttons,
  headingText,
  image,
  subtitleText,
}: Props) => {
  const { isMobile } = useMediaProps({
    [Screen.queries.phoneOnly]: {
      isMobile: true,
    },
  });

  return (
    <GridLayout
      areas={`
        "detail detail detail image"
        "detail detail detail image"
        "buttons buttons buttons image"
      `}
      columns="2fr 2fr 2fr 3fr"
      gap={40}
      propsQueries={{
        phoneOnly: {
          areas: `
            "detail detail detail"
            "detail detail detail"
            "buttons buttons buttons"
          `,
          columns: '2fr 2fr 2fr',
          gap: 10,
        },
      }}
    >
      <GridLayout area="detail">
        <Heading>{subtitleText}</Heading>
        <Spacer height={10} />
        <Heading css={styles.h2}>{headingText}</Heading>
        <Text tag="p" type="bodyText800">
          {bodyText}
        </Text>
      </GridLayout>
      <GridLayout area="buttons">
        <ButtonGroup
          direction="row"
          isFlex={true}
          propsQueries={{
            phoneOnly: { direction: 'column' },
          }}
        >
          {buttons}
        </ButtonGroup>
      </GridLayout>
      {!isMobile && (
        <GridLayout area="image">
          <div css={styles.imageContainer}>{image}</div>
        </GridLayout>
      )}
    </GridLayout>
  );
};

export default ContentWrapper;
